import React from 'react'

import Pause from './helper_functions/Pause'
import Play from './helper_functions/Play'
import useAudioPlayer from './helper_functions/useAudioPlayer.js'

export function Speaker() {
    const { playing, setPlaying } = useAudioPlayer()

    console.count('Speaker Component')

    return (
        <div className="controls">
            <audio id="audio">
                <source src="../audiotest.mp3" />
            </audio>
            {playing ? (
                <Pause handleClick={() => setPlaying(false)} />
            ) : (
                <Play handleClick={() => setPlaying(true)} />
            )}
        </div>
    )
}

export default Speaker
